webpackJsonp([58543583170675],{

/***/ 402:
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	
	var _propTypes = __webpack_require__(4);
	
	var _propTypes2 = _interopRequireDefault(_propTypes);
	
	var _react = __webpack_require__(3);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _heroVideo = __webpack_require__(41);
	
	var _heroVideo2 = _interopRequireDefault(_heroVideo);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var BrandPartnershipsPortfolio = function BrandPartnershipsPortfolio(_ref) {
	  var portfolio = _ref.portfolio;
	  return _react2.default.createElement(
	    'div',
	    { className: 'brand-portfolio' },
	    _react2.default.createElement(
	      'div',
	      { className: 'brand-portfolio__media' },
	      portfolio.map(function (_ref2) {
	        var node = _ref2.node;
	        return _react2.default.createElement(
	          'div',
	          { className: 'brand-portfolio__media--item', key: node.id },
	          _react2.default.createElement(
	            'div',
	            { className: 'brand-portfolio__video' },
	            _react2.default.createElement(_heroVideo2.default, {
	              desktopPosterSrc: node.image_desktop.url,
	              mobilePosterSrc: node.image_mobile.url,
	              desktopVideoSrc: node.loop_desktop.file.url,
	              mobileVideoSrc: node.loop_mobile.file.url,
	              desktopFullVideo: node.video_desktop,
	              mobileFullVideo: node.video_mobile,
	              node: node,
	              aspectRatio: '1:1',
	              autoPlay: false,
	              hoverPlay: true,
	              brandButton: true,
	              brandVideo: true
	            })
	          ),
	          _react2.default.createElement(
	            'div',
	            { className: 'brand-portfolio__title' },
	            node.title
	          )
	        );
	      })
	    )
	  );
	};
	
	BrandPartnershipsPortfolio.propTypes = {
	  portfolio: _propTypes2.default.array.isRequired
	};
	
	exports.default = BrandPartnershipsPortfolio;
	module.exports = exports['default'];

/***/ }),

/***/ 159:
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	
	var _propTypes = __webpack_require__(4);
	
	var _propTypes2 = _interopRequireDefault(_propTypes);
	
	var _react = __webpack_require__(3);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _heroVideo = __webpack_require__(41);
	
	var _heroVideo2 = _interopRequireDefault(_heroVideo);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var CaseStudies = function CaseStudies(_ref) {
	  var caseStudies = _ref.caseStudies,
	      awards = _ref.awards,
	      cta = _ref.cta;
	  return _react2.default.createElement(
	    'div',
	    { className: 'case-studies' },
	    caseStudies.map(function (_ref2) {
	      var node = _ref2.node;
	      return _react2.default.createElement(
	        'div',
	        { key: node.id, className: 'works-item' },
	        _react2.default.createElement(
	          'div',
	          { className: 'works-item__video' },
	          _react2.default.createElement(_heroVideo2.default, {
	            desktopPosterSrc: node.image_desktop.url,
	            mobilePosterSrc: node.image_mobile.url,
	            desktopVideoSrc: node.loop_desktop.file.url,
	            mobileVideoSrc: node.loop_mobile.file.url,
	            desktopFullVideo: node.video_desktop,
	            mobileFullVideo: node.video_mobile,
	            node: node,
	            aspectRatio: '16:9',
	            caseButton: true,
	            caseStudyVideo: true,
	            autoPlay: false,
	            loopPlay: true,
	            hoverPlay: true,
	            cta: cta
	          })
	        ),
	        _react2.default.createElement(
	          'div',
	          { className: 'works-item__details' },
	          _react2.default.createElement(
	            'span',
	            { className: 'works-item__platform' },
	            node.eyebrow
	          ),
	          _react2.default.createElement(
	            'h2',
	            { className: 'works-item__title' },
	            node.title
	          ),
	          _react2.default.createElement(
	            'div',
	            { className: 'works-item__description' },
	            _react2.default.createElement(
	              'p',
	              null,
	              node.description
	            )
	          ),
	          awards[node.eyebrow.toLowerCase()] ? _react2.default.createElement(
	            'div',
	            { className: 'works-item__awards' },
	            awards[node.eyebrow.toLowerCase()].map(function (award, index) {
	              return _react2.default.createElement(
	                'span',
	                { key: index.toString(), className: 'works-item__award' },
	                _react2.default.createElement('img', { src: award, alt: '' })
	              );
	            })
	          ) : null
	        )
	      );
	    })
	  );
	};
	
	CaseStudies.defaultProps = {
	  awards: {},
	  cta: 'View the work'
	};
	
	CaseStudies.propTypes = {
	  caseStudies: _propTypes2.default.array,
	  awards: _propTypes2.default.object
	};
	
	exports.default = CaseStudies;
	module.exports = exports['default'];

/***/ }),

/***/ 422:
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	exports.query = undefined;
	
	var _propTypes = __webpack_require__(4);
	
	var _propTypes2 = _interopRequireDefault(_propTypes);
	
	var _react = __webpack_require__(3);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _reactHelmet = __webpack_require__(22);
	
	var _reactHelmet2 = _interopRequireDefault(_reactHelmet);
	
	var _headerNew = __webpack_require__(26);
	
	var _headerNew2 = _interopRequireDefault(_headerNew);
	
	var _footerNew = __webpack_require__(15);
	
	var _footerNew2 = _interopRequireDefault(_footerNew);
	
	var _heroVideo = __webpack_require__(41);
	
	var _heroVideo2 = _interopRequireDefault(_heroVideo);
	
	var _scrollingBanner = __webpack_require__(97);
	
	var _scrollingBanner2 = _interopRequireDefault(_scrollingBanner);
	
	var _brandPortfolio = __webpack_require__(402);
	
	var _brandPortfolio2 = _interopRequireDefault(_brandPortfolio);
	
	var _caseStudies = __webpack_require__(159);
	
	var _caseStudies2 = _interopRequireDefault(_caseStudies);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var BrandPartnershipsPage = function BrandPartnershipsPage(_ref) {
	  var data = _ref.data;
	  return _react2.default.createElement(
	    'div',
	    { className: 'wrapper--page-dark page--brand-partnerships' },
	    _react2.default.createElement(_reactHelmet2.default, { title: 'Brand Partnerships - ATTN:' }),
	    _react2.default.createElement(_headerNew2.default, { theme: 'dark' }),
	    _react2.default.createElement(
	      'div',
	      { className: 'hero--fullbleed' },
	      _react2.default.createElement(_heroVideo2.default, {
	        desktopPosterSrc: data.drupalMedia.image_desktop.url,
	        mobilePosterSrc: data.drupalMedia.image_mobile.url,
	        desktopVideoSrc: data.drupalMedia.loop_desktop.file.url,
	        mobileVideoSrc: data.drupalMedia.loop_mobile.file.url
	      })
	    ),
	    _react2.default.createElement(
	      'div',
	      { className: 'brand-partnerships-intro' },
	      _react2.default.createElement(
	        'div',
	        { className: 'brand-partnerships-intro__body' },
	        'We give brands an editorial "in" with our audience of socially conscious doers and deciders.'
	      )
	    ),
	    _react2.default.createElement(_caseStudies2.default, { caseStudies: data.allDrupalProject.edges }),
	    _react2.default.createElement(_scrollingBanner2.default, { background: 'green', text: 'Our work', length: 10 }),
	    _react2.default.createElement(_brandPortfolio2.default, { portfolio: data.allDrupalPartner.edges }),
	    _react2.default.createElement(_footerNew2.default, null)
	  );
	}; /* global graphql  */
	
	
	BrandPartnershipsPage.propTypes = {
	  data: _propTypes2.default.object
	};
	
	exports.default = BrandPartnershipsPage;
	var query = exports.query = '** extracted graphql fragment **';

/***/ })

});


// WEBPACK FOOTER //
// component---src-pages-brandpartnerships-js-eaee291e51732595c6f9.js